import styled from 'styled-components';

export const IconSubTitleStyle = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 20px 0;
  img {
    margin-right: 20px;
  }
`